import { updateLinksAttributes } from '../utils';

export default function customFooterNavigation() {
  const widgetName = 'customFooterNavigation';
  const widgetOpts = customFooterNavigationOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($widget, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createFooterNavigation(data);
      } else {
        $widget.remove();
      }
    },
  });

  function createFooterNavigation(widgetData) {
    const items = (widgetData.items || []).filter((item) => item?.URL != null);

    if (!items.length) {
      $widget.remove();
      $('body').addClass(`${widgetName}-no-data`);
      return;
    }

    const $list = $('<ul />', {
      class: 'footer-navigation',
    });

    items.forEach(({ Title, URL }, index) => {
      const label = Title.trim();
      const $link = $('<a />', {
        href: URL,
        text: label,
      });

      updateLinksAttributes(URL, label, $link);

      const $item = $('<li />', {
        class: 'footer-navigation__item',
        'aria-haspopup': 'false',
      }).append($link);

      $list.append($item);

      if (index < items.length - 1) {
        $list.append(
          $('<li />', {
            class: 'footer-navigation__separator',
            'aria-hidden': 'true',
            text: '|',
          }),
        );
      }
    });

    $widget
      .attr({
        role: 'navigation',
        'aria-label': 'Footer navigation',
      })
      .empty()
      .append($list);
  }
}
